/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState, useContext } from 'react';
import { GridColumnTitle } from "components/Form";
import { FitinsurAPI, MessageCenter } from 'utils';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  InlineLabel,
  LabelEdit,
} from './styles';

export default function SchedullePeriods(props) {
  const [periods, setPeriods] = useState([]);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const history = useHistory();
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);

  function periodsSchedulle() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.processingPeriodsSchedule(props.idOperation, props.getLastImport, props.currentPeriod)
      .then(response => {
        return response.json()
      }).then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          //history.goBack();
          return;
        }
        console.log('periods ret_value', data.ret_value)
        setPeriods(data.ret_value);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${periodsSchedulle.name}\n` + error);
        console.error('PeriodsSchedule - Error:', error);
      })
      .finally(() => loading.stop());
  }

  useEffect(() => {
    periodsSchedulle();
  }, [])

  if (!periods || !periods.length) return <></>

  return (

    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>
            <GridColumnTitle>
              INSURER
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              FACILITY
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              DEPOSIT PREMIUM - COVERAGE PERIOD
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              TOTAL AMOUNT DEPOSIT PREMIUM
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              ADJUSTMENT PREMIUM - COVERAGE PERIOD
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              TOTAL AMOUNT ADJUSTMENT PREMIUM
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              PAYMENT DATE
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              TOTAL PREMIUM
            </GridColumnTitle>
          </TableHeader>
          <TableHeader>
            <GridColumnTitle>
              PERIOD
            </GridColumnTitle>
          </TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {periods.map((period, index) => (
          <TableRow key={index} hightlight={period.period === "Current"}>

            <TableCollum>
              <InlineLabel>
                INSURER
              </InlineLabel>
              <LabelEdit>
                {period.insurer}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                FACILITY
              </InlineLabel>
              <LabelEdit>
                {period.facilityName}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                DEPOSIT PREMIUM - COVERAGE PERIOD
              </InlineLabel>
              <LabelEdit>
                {period.coveragePeriodFrom} - {period.coveragePeriodTo}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                TOTAL AMOUNT DEPOSIT PREMIUM
              </InlineLabel>
              <LabelEdit>
                {period.currency}<br/>{period.depositPremium}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                ADJUSTMENT PREMIUM - COVERAGE PERIOD
              </InlineLabel>
              <LabelEdit>
                {period.coveragePeriodFromAp} - {period.coveragePeriodToAp}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                TOTAL AMOUNT ADJUSTMENT PREMIUM
              </InlineLabel>
              <LabelEdit>
                {period.currency}<br/>{period.adjustmentPremium}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                PAYMENT DATE
              </InlineLabel>
              <LabelEdit>
                {period.dpPaymentDate}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                TOTAL PREMIUM
              </InlineLabel>
              <LabelEdit>
                {period.currency}<br/>{period.totalPremium}
              </LabelEdit>
            </TableCollum>

            <TableCollum>
              <InlineLabel>
                PERIOD
              </InlineLabel>
              <LabelEdit>
                {period.period}
              </LabelEdit>
            </TableCollum>

          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}